import {EventShop} from "./EventShop";
import {utils} from "../utils";

/**
 *  Класс описывающий реализацию абонемента
 * @extends EventShop
 */
export class SubscriptionShop extends EventShop {
	constructor() {
		super();
		this.arrayOfPlaces = [];
		this.subscriptionCount = null;
		this.subSeatCount = null;
		this.$previousSvg = null;
		this.$back = null;
		this.$placesSvg = null;
		this.$placesLegend = null;
		this.$placesInfo = null;
		this.$bottom = null;
		this.$placesFixed = null;
		this.$placesOpen = null;
		this.$chooseSector = null;
		this.$placesBuy = null;
		this.arrayOfPlaces = [];
		this.$tooltip = null;
		this.$placesSum = null;
		this.subSeatCount = null;
		this.eventId = null;
		this.subEventId = null;
		this.subUnittId = null;
		this.oldPrice = $("#js-subscription-old-price");
	}

	getCurrentSubscriptionCartCount(needOverlay) {
		this.arrayOfPlaces = [];
		return this.getSubscriptionCartCount(needOverlay).then(res => {
			$.each(res, (index, elem) => {
				this.arrayOfPlaces.push(elem);
			});
		});
	}

	addActionToPlaces() {
		this.$elements.on("click", e => {
			const element = $(e.currentTarget);
			const sid = element.attr("id");
			const isPack = element.data("ispack");
			if (isPack) {
				element.data("available", "true");
			}
			const isCart = element.data("available");
			if (isCart === "true") {
				if (!isPack) {
					element.data("available", "false");
				}
				this.addToSubscriptionCart(sid);
			} else if (isCart === "false") {
				element.data("available", "true");
				this.removeFromSubscriptionCart(sid);
			}
		});
	}

	addActionToBack() {
		this.$back.off();
		this.$back.on("click", () => {
			this.$placesSvg.fadeOut("fast", () => {
				//плавно скрывает план сектора
				this.$placesSvg.html(this.$previousSvg);
				this.$placesSvg.removeClass("openedSector");
				this.$back.hide();
				this.getZones(this.subEventId).then(res => {
					this.setZones(res);
					this.addActionToPricesLabelToSector();
				});
				this.$placesLegend.hide();
				this.$choosePlaces.hide();
				this.$chooseSector.show();
				this.$svg = $("#svg");
				this.$elements = this.$svg.find("g[mode]");
				this.addActionToSector();
				this.$placesSvg.fadeIn("slow");
				this.$placesInfo.addClass("places__info_sector");
				this.$prices.addClass("places__prices_sector");
			});
		});
	}

	actionAfterChooseSector(svg) {
		this.$places.off();
		this.$placesSvg.html(svg);
		this.$placesSvg.addClass("openedSector");
		this.$svg = $("#svg");
		this.$svgElement = this.$svg;
		this.$elements = this.$svg.find("g[mode]");
		this.setSvgPlan();
		this.$back.show();
		this.$choosePlaces.show();
		this.$chooseSector.hide();
		this.addActionToBack();
		this.addActionToPlaces();
		this.$placesSvg.fadeIn("slow"); //добавляет анимацию появления после загрузки
		this.setEventId();
	}

	getPricesAfterChooseSector(viewId, event_id = false, svgLocal) {
		this.getPrices(viewId, event_id)
			.then(response => {
				this.$elements.addClass("default");
				this.setColorToPlace(response);
				this.setPricesLabelToPlace(this.zones);
				this.addActionToPricesLabelToPlace();
				try {
					localStorage.setItem(
						`${this.subUnittId}_${viewId}`,
						JSON.stringify({
							svg: svgLocal.svg ? svgLocal.svg : svgLocal,
							prices: response.prices,
							zones: response.zones,
							time: +new Date(),
						})
					);
				} catch (e) {}
			})
			.then(() => {
				this.$placesSvg.removeClass("loading");

				$.each(this.arrayOfPlaces, (index, elem) => {
					if (Number(elem.event_id) === this.subEventId) {
						const selector = $(`#${elem.sid}`);
						selector.addClass("in-cart").data("available", "false");
					}
				});
				if (Number($("#js-places-choose").text()) === this.subscriptionCount) {
					this.$elements.addClass("inactive");
				}
			});
	}

	addActionAfterOpenSubscrSector(response) {
		this.$elements.addClass("default");
		this.setColorToPlace(response);
		this.setPricesLabelToPlace(this.zones);
		this.addActionToPricesLabelToPlace();
		this.$placesSvg.removeClass("loading");
		this.$placesSvg.fadeIn("slow"); //добавляет анимацию появления после загрузки
		$.each(this.arrayOfPlaces, (index, elem) => {
			if (Number(elem.event_id) === this.subEventId) {
				const selector = $(`#${elem.sid}`);
				selector.addClass("in-cart").data("available", "false");
			}
		});
		if (Number($("#js-places-choose").text()) === this.subscriptionCount) {
			this.$elements.addClass("inactive");
		}
	}

	addActionToSector() {
		$.each(this.$elements, (index, elem) => {
			const sector = $(elem);
			const viewId = sector.attr("view_id");
			sector.on("click", () => {
				// this.$overlay.show();
				this.$previousSvg = this.$svg;
				// this.$placesSvg.addClass("loading");
				this.$placesSvg.fadeOut("fast"); //скрывает элемент при загрузке

				const limit = (this.storageLimit || 3) * 60 * 1000; //Переводим в миллисекунды  (по умолчанию 3 минуты)
				// let svgLocal = localStorage.getItem(`${this.subUnittId}_${viewId}`);
				let svgLocal = false;
				try {
					//Пытаемся преобразовать в объект план сектора с хранилища
					svgLocal = JSON.parse(svgLocal);
				} catch (e) {}

				if (!svgLocal) {
					this.getSvgPrices(this.subEventId, viewId).then(response => {
						this.actionAfterChooseSector(response.svg);
						try {
							localStorage.setItem(
								`${this.subUnittId}_${viewId}`,
								JSON.stringify({
									svg: response.svg,
									prices: response.prices,
									zones: response.zones,
									time: +new Date(),
								})
							);
						} catch (e) {}
						this.addActionAfterOpenSubscrSector(response);
					});
				} else {
					if (!svgLocal.time) {
						//Загружаем план сектора из хранилища и загружаем цены и места в секторе
						this.addActionToLoadSectorPrices(svgLocal, viewId);
					} else {
						if (+new Date() - svgLocal.time > limit) {
							//Если время лимита прошло то обновляем цены и места в секторе
							this.addActionToLoadSectorPrices(svgLocal, viewId);
						} else {
							//Загружаем план сектора из хранилища и добавляем анимацию
							this.$placesSvg.fadeOut("fast", () => {
								this.actionAfterChooseSector(svgLocal.svg);
								this.addActionAfterOpenSubscrSector(svgLocal);
							});
						}
					}
				}
				this.getCurrentSubscriptionCartCount();
				this.$placesInfo.removeClass("places__info_sector");
			});
		});
	}

	setEventId() {
		this.eventId = this.$subscriptionMain.data("event");
		if (!this.eventId) {
			this.eventId = $(".subscription_index").data("event");
		}
	}

	addActionToLoadSectorPrices(svgLocal, viewId) {
		this.$placesSvg.fadeOut("fast", () => {
			this.actionAfterChooseSector(svgLocal.svg ? svgLocal.svg : svgLocal);
		});
		this.getPricesAfterChooseSector(viewId, this.subEventId, svgLocal);
	}

	updateSum(places) {
		const sum = this.$placesSum.find(".js-sum");
		sum.text("");
		$.each(places, (index, elem) => {
			sum.text(Number(sum.text()) + elem.price);
		});
	}

	addToSubscriptionCart(sid) {
		this.addToSubscriptionCartApi(sid)
			.then(res => {
				if (res.places) {
					const tickets = $(".tickets_fixed");

					if (this.isDesktop.matches) {
						tickets.show();
					}

					tickets.find(".js-tickets-items").html("");

					$.each(res.places, (index, elem) => {
						$(`#${elem.sid}`).addClass("in-cart");
						const ticket = this.insertDataToTicket(elem, false, false);
						$(".tickets_fixed .js-tickets-items").append(ticket);
					});
					this.updateSum(res.places);
					this.updateActiveSeat(sid, true);
					$("#js-places-choose").text(Number($("#js-places-choose").text()) + 1);
					if (Number($("#js-places-choose").text()) >= this.subscriptionCount) {
						this.$elements.addClass("inactive");
					}
					if (Number($("#js-places-choose").text()) === this.subscriptionCount) {
						this.$placesBuy.removeClass("inactive");
					}

					if (!this.$bottom.hasClass("active")) {
						this.$bottom.addClass("active");
					}
					if (!this.$placesOpen.hasClass("active")) {
						this.$placesOpen.addClass("active");
					}
					if (!this.$placesFixed.hasClass("active")) {
						this.$placesFixed.addClass("active");
					}
					if (!$("#js-popup-modal").hasClass("active")) {
						$("#js-popup-modal").addClass("hide-close");
					}
					if (!$(".js-places-open").hasClass("visible")) {
						$(".js-places-open").addClass("visible");
					}
					const count = $(".js-places-open .js-count");
					count.text(Number(count.text()) + 1);
					$(".js-places-open .js-count-word").text(
						" " +
							utils.wordEnding(Number(count.text()), [
								this.getWord("event", "ticket"),
								this.getWord("event", "tickets"),
								this.getWord("event", "tickets "),
							])
					);
					const color = $(`#${sid}`).data("color");
					const storageObject = {sid, color};
					const getStorage = utils.getObjectFromSessionStorage(this.subEventId);
					if (getStorage) {
						getStorage.push(storageObject);
						utils.setObjectToSessionStorage(this.subEventId, getStorage);
					} else {
						this.storageArr.push(storageObject);
						utils.setObjectToSessionStorage(this.subEventId, this.storageArr);
					}
				}
			})
			.then(() => {
				this.getSubscriptionCartCount();

				if (this.isDesktop.matches) {
					this.setTransformForTickets();
				}
			});
	}

	updateOtherSubscriptionSeats(res) {
		let sum = 0;

		$.each(res, (i, order) => {
			$.each(order.carts, (j, item) => {
				const ticketItem = $(`.tickets__item[data-uid="${item.uid}"]`);
				if (ticketItem.length) {
					sum += item.price;
				}
				ticketItem.find(".js-ticket-price").text(item.price);
			});
		});
		$("#js-subscription-score").text(sum);
	}

	removeFromSubscriptionCart(sid) {
		this.removeFromSubscriptionCartApi(this.eventId, this.subEventId, sid)
			.then(res => {
				if (res.error) {
					window.location.reload();
				}

				$(`#${sid}`).removeClass("in-cart");
				$(`.tickets__item[data-place="${sid}"]`).remove();
				let count = Number($("#js-places-choose").text()) - 1;
				if (count <= 0) {
					count = 0;
					$(".js-places-open").removeClass("visible");
				}
				this.updateActiveSeat(sid, false);
				$("#js-places-choose").text(count);
				$(".js-places-open .js-count").text(count);
				$(".js-places-open .js-count-word").text(
					" " +
						utils.wordEnding(Number(count), [
							this.getWord("event", "ticket"),
							this.getWord("event", "tickets"),
							this.getWord("event", "tickets "),
						])
				);
				if (Number($("#js-places-choose").text()) < this.subscriptionCount) {
					this.$elements.removeClass("inactive");
				}
				if (Number($("#js-places-choose").text()) !== this.subscriptionCount) {
					this.$placesBuy.addClass("inactive");
				}
				this.updateSum(res.places);
				if (Array.isArray(res.places) && !res.places.length) {
					this.$bottom.removeClass("active");
					this.$placesOpen.removeClass("active");
					$(".places__fixed").removeClass("active");
					$("#js-popup-modal").removeClass("hide-close");
					this.arrayOfPlaces = [];
				}

				$(".places-description-ticket").text(
					utils.wordEnding(res.count, [
						this.getWord("event", "ticket"),
						this.getWord("event", "tickets"),
						this.getWord("event", "tickets "),
					])
				);
				const places = [];

				for (let population in res.places) {
					if (res.places.hasOwnProperty(population)) {
						places.push(population);
					}
				}

				const getStorage = utils.getObjectFromSessionStorage(this.subEventId);

				for (let i = 0; i < getStorage.length; i++) {
					if (getStorage[i].sid === sid) {
						const colorStorage = getStorage[i].color;
						const color = $(`.places__input[data-color="${colorStorage}"]`).data(
							"color"
						);
						$(`#${sid}`).removeClass("disabled");
						$(`#${sid}`).find("rect").css("fill", color);
						$(`#${sid}`).find("ellipse").css("fill", color);
						$(`#${sid}`).find("circle").css("fill", color);
						getStorage.splice(i, 1);
					}
				}
				utils.setObjectToSessionStorage(this.subEventId, getStorage);
			})
			.then(() => {
				this.getSubscriptionCartCount().then(res => {
					if (Array.isArray(res) && !res.length) {
						$(".js-tickets").hide();
						$(".places__svg").removeClass("inactive");
						$(".places__prices").removeClass("inactive");
						$("html").removeClass("overflow-hidden");
						$(".js-places-open .js-count").text("");
						$(".js-count-word").text("");
					}
				});

				this.getCartCount(this.eventId).then(res => {
					this.updateOtherSubscriptionSeats(res);
				});

				if (this.isDesktop.matches) {
					this.setTransformForTickets();
				}

				this.calculateTotalSumm();
			});
	}

	calculateTotalSumm() {
		let sum = 0;
		let defaultSum = 0;
		$(".js-ticket-price").each(function () {
			if ($(this).closest(".js-text-parent").find(".js-subscription-checkbox").is(":checked"))
				sum += Number($(this).data("price"));
			defaultSum += Number($(this).data("default"));
		});

		if (defaultSum && defaultSum !== sum) {
			this.oldPrice.text(defaultSum).parent().show();
		} else {
			this.oldPrice.text(0).parent().hide();
		}

		this.$sum.text(sum);

		this.checkBuyButton();
	}

	checkBuyButton() {
		if (this.$sum.text() == "" || this.$sum.text() == 0 || !this.$checkboxes.is(":checked")) {
			this.$buy.addClass("disabled");
		} else this.$buy.removeClass("disabled");
	}
}
